'use client';

import { Amplify } from 'aws-amplify';
import config from '@/amplifyconfiguration.json';
import { ReactNode, useEffect } from 'react';

interface AmplifyProviderProps {
  children: ReactNode;
}

export default function AmplifyProvider({ children }: AmplifyProviderProps) {
  useEffect(() => {
    // クライアントサイドでのみAmplifyを初期化
    try {
      // 環境に応じてOAuth設定を調整
      const isDevelopment = process.env.NODE_ENV === 'development';
      const currentDomain = typeof window !== 'undefined' ? window.location.origin : '';
      
      // 環境変数から設定を取得（設定されていない場合はデフォルト値を使用）
      const customRedirectSignIn = process.env.NEXT_PUBLIC_OAUTH_REDIRECT_SIGN_IN;
      const customRedirectSignOut = process.env.NEXT_PUBLIC_OAUTH_REDIRECT_SIGN_OUT;
      const customClientId = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID;
      
      let amplifyConfig = { ...config };
      
      // 環境変数からクライアントIDを設定
      if (customClientId) {
        amplifyConfig.aws_user_pools_web_client_id = customClientId;
        console.log('環境変数からクライアントID設定:', customClientId);
      }
      
      // カスタムリダイレクトURLが設定されている場合は優先
      if (customRedirectSignIn || customRedirectSignOut) {
        amplifyConfig = {
          ...amplifyConfig,
          oauth: {
            ...amplifyConfig.oauth,
            redirectSignIn: customRedirectSignIn || amplifyConfig.oauth.redirectSignIn,
            redirectSignOut: customRedirectSignOut || amplifyConfig.oauth.redirectSignOut,
          },
        };
        console.log('環境変数からOAuth設定適用:', amplifyConfig.oauth);
      } else if (isDevelopment && currentDomain) {
        // 開発環境では現在のドメインを使用し、スコープも調整
        amplifyConfig = {
          ...amplifyConfig,
          oauth: {
            ...amplifyConfig.oauth,
            redirectSignIn: `${currentDomain}/`,
            redirectSignOut: `${currentDomain}/`,
            // 開発環境では基本的なスコープのみ使用
            scope: [
              "email",
              "openid",
              "profile"
            ],
          },
        };
        console.log('開発環境用Amplify設定適用:', amplifyConfig.oauth);
      }
      
      Amplify.configure(amplifyConfig);
      console.log('Amplify設定完了:', {
        environment: isDevelopment ? 'development' : 'production',
        domain: currentDomain,
        redirectSignIn: amplifyConfig.oauth.redirectSignIn,
        redirectSignOut: amplifyConfig.oauth.redirectSignOut,
        scope: amplifyConfig.oauth.scope,
      });
    } catch (error) {
      console.error('Amplify configuration error:', error);
    }
  }, []);

  return <>{children}</>;
} 